import axios from 'axios';

export const fetchPaymentMethods = async ({
	commit,
	dispatch,
	state
}, params) => {

  return new Promise((resolve, reject) => {
    axios.get('/api/v2/me/payments/preferences')
      .then(response => {
        if (response.status === 200) {
          commit('setPaymentMethods', response.data.data);

          setTimeout(() => {
            resolve(response.data.data)
          }, 200)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}
